import { createRouter, createWebHistory } from 'vue-router'
import Home from '../components/Home.vue'
import EmailVerification from '../components/EmailVerification.vue'
import AboutPage from "../components/AboutPage.vue"
import PrivacyPage from "../components/PrivacyPage.vue"
import BestPage from "../components/BestPage.vue"

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/verify_email',
        name: 'EmailVerification',
        component: EmailVerification
    },
    {
        path: '/user',
        name: 'UserPage',
        component: () => import('../components/UserPage.vue') // Lazy load
    },
    {
        path: '/about',
        name: 'about',
        component: AboutPage
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: PrivacyPage
    },
    {
        path: '/best',
        name: 'BestIndexPage',
        component: () => import('../components/BestIndexPage.vue')
    },
    {
        path: '/best/:slug',
        name: 'BestPage',
        component: BestPage
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router